import React from 'react';
import CommanBanner from '../elements/CommanBanner';
import { IMAGES } from '../constants/theme';
const LegalPage = ({ title, children }) => {
  return (
    <div className="page-content bg-white">
      <CommanBanner mainTitle={title} bgImage={IMAGES.bnr9} />
      <div className="content-inner">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-8 col-lg-8 offset-xl-2 offset-lg-2">
              <div className="dz-card blog-single style-1">
                <div className="dz-info">
                  <h1 className="mb-4">{title}</h1>
                  {children}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalPage; 